import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'lp-components'
import { IMAGE_PATH } from 'config'

const propTypes = {
  buttonText: PropTypes.string.isRequired,
  confirmationHandler: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
}

function OnlineAccountNextSteps({
  buttonText,
  confirmationHandler,
  description,
}) {
  return (
    <>
      <img alt="" src={IMAGE_PATH.ANCHOR_ICON} className="confirmation-icon" />
      <h2>Access Your Online Account Anytime, Anywhere</h2>
      <p>{description}</p>

      <div className="text-block">
        <div className="text-block-item">
          <strong>With your online account, you can:</strong>
          <ul className="bullets">
            <li>Manage your Automatic Renewal enrollment</li>
            <li>Update your membership details</li>
            <li>Explore member-only videos and blog content</li>
            <li>
              Access exclusive deals and discounts through Sea Tow Savings
              Club&trade;
            </li>
          </ul>
        </div>
      </div>
      <Button onClick={confirmationHandler}>{buttonText}</Button>
    </>
  )
}

OnlineAccountNextSteps.propTypes = propTypes

export default OnlineAccountNextSteps
